var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"azcon-slider-skeleton"},[_c('div',{staticClass:"azcon-slider-skeleton__image"}),_c('div',{staticClass:"azcon-slider-skeleton__dots"},_vm._l((3),function(i){return _c('span',{key:i,staticClass:"azcon-slider-skeleton__dot"})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }